<template>
  <div>
    <Pagenation :index="index" :total="total" @showOther="showOther" @showList="showList">
      <template v-if="infoApiStatus.status === 200">
        <b-button @click="handleClickEdit(selectedAnnouncement.announcement_id)" variant="outline-info rounded-pill">
          <b-icon icon="pencil" variant=""></b-icon>
          &nbsp;編集
        </b-button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <b-button
          @click="handleClickDelete(selectedAnnouncement.announcement_id)"
          variant="outline-secondary rounded-pill"
        >
          <b-icon icon="trash" variant=""></b-icon>
          &nbsp;削除
        </b-button>
      </template>
    </Pagenation>

    <b-card class="mb-3">
      <ErrorMessage :status="infoApiStatus.status" :customMessage="infoApiStatus.customMessage" />
      <template v-if="infoApiStatus.status === 200">
        <div class="announcement-header d-flex justify-content-between flex-wrap">
          <h1 class="announcement-title">
            {{ selectedAnnouncement.title }}
            <span v-if="selectedAnnouncement.publishing_status !== '0'" class="draft">
              ({{ $constList.announcementStateList[selectedAnnouncement.publishing_status] }})
            </span>
          </h1>
          <span class="notice-date">公開期間：{{ dates }}</span>
        </div>
        <div class="announcement-body">
          <ElementAutoLink :text="selectedAnnouncement.body"></ElementAutoLink>
        </div>
      </template>

      <hr />

      <AnnouncementDetailReplyList
        :announcement="selectedAnnouncement"
        noDataMessage="宛先はすべて削除されました"
        @filter-reply="setFilteredReactions($event)"
        :replyFields="getReplyFields(true)"
        :showUnread="true"
        @click-profile="handleClickProfile($event)"
      >
        <template v-slot:header>
          <h2 class="announcement-title">反応</h2>
          <b-button
            variant="info"
            size="sm"
            class="ml-2"
            v-show="filteredReactions.length && reactionApiStatus.status === 200"
            @click="downloadReplyList()"
          >
            既読状況ダウンロード
          </b-button>
        </template>
        <template v-slot:bottom>
          <b-form inline>
            <b-form-select id="reply" v-model="replyType" size="sm" :options="replyOptions"></b-form-select>
            <span v-if="usersToNewAnnouncement.length">
              ({{ usersToNewAnnouncement.length }}人)に
              <app-button class="default" @click="createAnnouncement()">お知らせ作成</app-button>
            </span>
            <span v-else>の人はいません</span>
          </b-form>
        </template>
      </AnnouncementDetailReplyList>
    </b-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import baseJs from '@/transformer/base'
import { getReplyText, getReplyList, replyStateList, getReplyOptions } from '@/transformer/announcement'
import { downloadCsv } from '@/transformer/file'

import ErrorMessage from '@/components/ErrorMessage.vue'
import ElementAutoLink from '@/components/presentationals/ElementAutoLink.vue'
import AppButton from '@/components/presentationals/AppButton'
import Pagenation from '@/components/Pagenation.vue'
import AnnouncementDetailReplyList from '@/components/Announcement/AnnouncementDetailReplyList'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AnnouncementDetailForAdmin',
  components: {
    ElementAutoLink,
    AppButton,
    AnnouncementDetailReplyList,
    Pagenation,
    ErrorMessage
  },
  props: {
    index: Number,
    total: Number
  },
  data: function () {
    return {
      replyType: 100,
      filteredReactions: []
    }
  },
  computed: {
    ...mapState({
      infoApiStatus: (state) => state.Announcement.infoApiStatus,
      reactionApiStatus: (state) => state.Announcement.listReactionApiStatus,
      listReaction: (state) => state.Announcement.listReaction
    }),
    ...mapGetters('Announcement/', ['selectedAnnouncement']),
    replyOptions: function () {
      return getReplyOptions(this.announcement)
    },
    dates: function () {
      var tmpText = dayjs(this.selectedAnnouncement.started_at).format('YYYY年MM月DD日') + '〜'
      if (this.selectedAnnouncement.ended_at) {
        tmpText += '\n' + dayjs(this.selectedAnnouncement.ended_at).format('YYYY年MM月DD日')
      }
      if (this.selectedAnnouncement.created_at !== this.selectedAnnouncement.updated_at) {
        tmpText += '\n(' + dayjs(this.selectedAnnouncement.updated_at).format('YYYY年MM月DD日') + ' 更新)'
      }
      return tmpText
    },
    endedAt: function () {
      if (!this.selectedAnnouncement.ended_at) {
        return '無期限'
      }
      return dayjs(this.selectedAnnouncement.ended_at).format('YYYY年MM月DD日')
    },
    usersToNewAnnouncement: function () {
      const users = this.filteredReactions
        .filter((e) => {
          if (this.replyType === 100) {
            return true
          }
          // 状態が一致するもののみ
          if (this.replyType < 3) {
            return this.replyType === Number(e.status)
          }
          // 未読と既読
          if (this.replyType === 3) {
            return Number(e.status) < 2
          }
          // 返信の内容が一致するか
          if (Number(e.status) === 2 && Number(e.reply) === this.replyType - 10) {
            return true
          }
          return false
        })
        .map((userData) => {
          return userData.id
        })
      return users
    }
  },
  methods: {
    setFilteredReactions: function (reactionList) {
      this.filteredReactions = reactionList
    },
    downloadReplyList: function () {
      const header = ['氏名', '返信状況', '返信内容', 'コメント']
      const data = this.filteredReactions.map((e) => {
        return [
          e.name,
          this.$constList.replyStateList[e.status],
          getReplyText(this.selectedAnnouncement, e.reply),
          e.comment
        ]
      })
      if (!data.length) {
        this.announcementApiData.customMessage = 'ダウンロードできるデータがありませんでした。'
        this.announcementApiData.status = 400
        return
      }
      //  見出し行を追加
      data.unshift(header)
      downloadCsv(
        data,
        'お知らせ「' +
          this.selectedAnnouncement.title +
          '」の返答状況_' +
          dayjs(new Date()).format('YYYY年MM月DD日') +
          '.csv'
      )
    },
    createAnnouncement: function () {
      this.$emit('createNewAnnouncement', this.usersToNewAnnouncement)
    },
    handleClickProfile($event) {
      this.$emit('click-profile', $event)
    },
    handleClickEdit($event) {
      this.$emit('click-edit', $event)
    },
    handleClickDelete() {
      this.$emit('click-delete')
    },
    showOther(index) {
      this.$emit('showOther', index)
    },
    showList() {
      this.$emit('showList')
    },
    getReplyFields: function (showAll = true) {
      return [
        { key: 'name', label: '名前', sortable: showAll, textSearch: true },
        {
          key: 'status',
          label: '状態',
          sortable: showAll,
          selectSearch: baseJs.getSelectionsByObject(replyStateList, true)
        },
        { key: 'reply', label: '返信', sortable: showAll, selectSearch: getReplyList(this.selectedAnnouncement) },
        { key: 'comment', label: 'コメント', sortable: showAll, textSearch: true },
        { key: 'updated_at', label: '更新日時', sortable: showAll, dateSearch: true }
      ]
    }
  },
  mounted() {
    this.setFilteredReactions(this.listReaction)
  },
  watch: {
    listReaction() {
      this.setFilteredReactions(this.listReaction)
    }
  }
}
</script>

<style scoped>
.announcement-title {
  font-size: 24px;
  display: inline-block;
}

.notice-date {
  font-size: 12px;
  display: inline-block;
  line-height: 24px;
}

.announcement-body {
  white-space: pre-wrap;
  padding: 5px;
  font-size: 14px;
}

.announcement-footer {
  padding: 5px;
  margin-top: 10px;
}

.draft {
  font-size: 12px;
}
</style>
